import api from './api';
import {CHANNELS_SET_ACTIVE} from './channels';

import NetworkError from '../utils/error/NetworkError';

export const PRODUCTS_SET_PRODUCT = 'PRODUCTS_SET_PRODUCT';

const initialState = {};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case PRODUCTS_SET_PRODUCT:
      return {
        ...state,
        [payload.slug]: payload.product
      };
    case CHANNELS_SET_ACTIVE:
      return initialState;
    default:
      return state;
  }
}

export function setProduct(slug, product) {
  if (product) {
    const timingRegExp = /{([\d.-]+?)}/;
    product.variants.filter(variant => !!variant.optionSet).forEach(variant => {
      variant.optionSet.options = variant.optionSet.options.map(option => {
        const timingTag = option.name.match(timingRegExp);

        if (!timingTag) {
          return option;
        }

        const timingModifier = parseFloat(timingTag[1]);

        return {
          ...option,
          name: option.name.replace(timingRegExp, ''),
          timing: {operation: '*', modifier: Number.isNaN(timingModifier) ? 1 : timingModifier}
        };
      });
    });
  }

  return {type: PRODUCTS_SET_PRODUCT, payload: {slug, product}};
}

export function fetchProductBySlug(slug, cookies) {
  return dispatch => {
    dispatch(setProduct(slug, null));

    return dispatch(api.get(`products/by-slug/${slug}`, undefined, {cache: 'default'}))
      .then(productResponse => {
        const product = productResponse.content;

        if (cookies && cookies.blacklist) {
          const excludedTaxons = JSON.parse(cookies.blacklist);
          const mainTaxonSlug = (product && product.mainTaxon) ? product.mainTaxon.slug : undefined;
          const mainTaxonParentSlugs = (product && product.mainTaxonParents)
            ? product.mainTaxonParents.filter(taxon => taxon.code !== 'game').map(taxon => taxon.slug)
            : [];

          const taxonSlugs = [mainTaxonSlug, ...mainTaxonParentSlugs];

          if (excludedTaxons.some(excludedTaxon => taxonSlugs.includes(excludedTaxon))) {
            return Promise.reject(new NetworkError(404, {code: 404, message: 'Not Found'}));
          }
        }

        dispatch(setProduct(slug, product));
        return product;
      })
      .catch(err => {
        if (err.status === 404) {
          dispatch(setProduct(slug, false));
        }

        throw err;
      })
  };
}



// WEBPACK FOOTER //
// ./ducks/products.js